import {ConversionLogFilter} from "./ConversionLogFilter";

export class ConversionLogsSelectionOptions {
    selectedIds: number[] = [];
    allSelected: boolean = false;
    filter?: ConversionLogFilter;
}